import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App';

class CertificationLink extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	_getLinkValue() {
		if (this.props.value) {
			var url = `/admin/certification/${this.props.dependentValues.certificationKey}`;

			if (this.props.dependentValues.queueTypeCode === 'STR' && App.hasPrivilege("AdminSiteReviewAccess"))
				url = `/admin/siteReview/${this.props.dependentValues.certificationKey}`;

			return {
				url: url,
				title: this.props.value
			};
		}
		else return null;
	}

	render() {
		if (this.props.value)
			return <Link value={this._getLinkValue()}></Link>

		return null
	}
}

export default CertificationLink;


// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/CertificationLink.js